// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7 19C6.17157 19 5.5 18.3284 5.5 17.5C5.5 16.6716 6.17157 16 7 16C7.82843 16 8.5 16.6716 8.5 17.5C8.5 18.3284 7.82843 19 7 19ZM3.5 17.5C3.5 19.433 5.067 21 7 21C8.933 21 10.5 19.433 10.5 17.5C10.5 15.567 8.933 14 7 14C5.067 14 3.5 15.567 3.5 17.5ZM8 12L8 4L6 4L6 12L8 12ZM17 8C16.1716 8 15.5 7.3284 15.5 6.5C15.5 5.6716 16.1716 5 17 5C17.8284 5 18.5 5.6716 18.5 6.5C18.5 7.3284 17.8284 8 17 8ZM13.5 6.5C13.5 8.433 15.067 10 17 10C18.933 10 20.5 8.433 20.5 6.5C20.5 4.567 18.933 3 17 3C15.067 3 13.5 4.567 13.5 6.5ZM16 20L18 20L18 12L16 12L16 20Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
